module.exports = __webpack_public_path__ + "static/media/annootate.b9f68df5.gif";